/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { taskFor } from 'ember-concurrency-ts';
import { ReactRoute } from 'embercom/lib/react-route';
import { StandalonePlatform } from 'embercom/objects/standalone/constants';

class DeployOverviewRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;
  @service declare appService: {
    app: {
      hasStandalonePlatform: (platform: string) => boolean;
      id: string;
      canUseStandaloneConnectPage: boolean;
      canUseReactGenericDeployPages: boolean;
    };
  };

  async beforeModel() {
    if (this.reactEnabled()) {
      return;
    }

    await Promise.all([
      this.finStandaloneService.initialize(),
      this.finStandaloneService.intercomMessengerConfig.ruleset.promise,
      taskFor(this.finStandaloneService.loadAiContentLibrarySummary).last!,
    ]);
  }

  reactEnabled() {
    return (
      this.appService.app.canUseStandaloneConnectPage ||
      (this.appService.app.hasStandalonePlatform(StandalonePlatform.Unknown) &&
        this.appService.app.canUseReactGenericDeployPages)
    );
  }
}

export default ReactRoute(DeployOverviewRoute);
